import React from "react";

import { Stepper as MuiStepper, Step, StepContent, StepLabel, Typography, withStyles } from "@material-ui/core";

import useColourPalette from "components/visuals/useColourPalette";
import SimpleTooltip from "components/SimpleTooltip";
import { SimpleTooltipPlacement } from "components/SimpleTooltip";

import StepIcon from "./StepIcon";

import { useAppSelector } from "store";
import { selectActiveStep, selectCandidatePartner, selectCandidateOperator } from "modules/customer/tools/product/partnerFilters/partnerFiltersSlice";

const StyledStepper = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.dark,
        paddingLeft: theme.spacing(0)
    }
}))(MuiStepper);

const Stepper: React.FC = () => {
    const colourPalette = useColourPalette();
    const activeStep = useAppSelector(selectActiveStep);
    const candidatePartner = useAppSelector(selectCandidatePartner);
    const candidateOperator = useAppSelector(selectCandidateOperator);

    return (
        <StyledStepper activeStep={activeStep} orientation="vertical">
            <Step expanded>
                <StepLabel StepIconComponent={StepIcon}>
                    <Typography variant="subtitle1" component="div">
                        Select a partner
                    </Typography>
                </StepLabel>
                <StepContent style={{ color: colourPalette.comparators[0] }}>
                    <SimpleTooltip title={candidatePartner?.name ?? ""} placement={SimpleTooltipPlacement.RightEnd}>
                        <Typography variant="h6" component="div" noWrap>
                            {candidatePartner?.name}
                        </Typography>
                    </SimpleTooltip>
                </StepContent>
            </Step>
            <Step expanded>
                <StepLabel StepIconComponent={StepIcon}>
                    <Typography variant="subtitle1" component="div">
                        Select an operator
                    </Typography>
                </StepLabel>
                <StepContent style={{ color: colourPalette.comparators[0] }}>
                    <SimpleTooltip title={candidateOperator?.name ?? ""} placement={SimpleTooltipPlacement.RightEnd}>
                        <Typography variant="h6" component="div" noWrap>
                            {candidateOperator?.name}
                        </Typography>
                    </SimpleTooltip>
                </StepContent>
            </Step>
        </StyledStepper>
    );
};

export default Stepper;
